import clsx from "clsx";
import { ReactNode } from "react";
import { Radio as RARadio, RadioProps } from "react-aria-components";
import styles from "./RadioButton.module.css";
import {
  RadioButtonRecipeProps,
  radioButtonStyles,
} from "./RadioButton.recipe";

interface RadioButtonProps extends RadioProps, RadioButtonRecipeProps {
  children: ReactNode;
  value: string;
  description?: string;
}

const RadioButton = ({
  value,
  fontWeight = "bold",
  radioIconPosition = "insetInlineStart",
  children,
  className,
  description,
  ...props
}: RadioButtonProps) => {
  return (
    <div className={styles.radioContainer}>
      <RARadio
        value={value}
        className={clsx(
          radioButtonStyles({ fontWeight, radioIconPosition }),
          className,
        )}
        {...props}
      >
        <span className={styles.radioIcon}></span>
        <div className={styles.radioLabel}>{children}</div>
      </RARadio>
      {description && (
        <div className={styles.radioDescription}>{description}</div>
      )}
    </div>
  );
};

export default RadioButton;
